import { Component, EventEmitter, Output } from '@angular/core';
import { ExcelService } from './services/excel.service';
import { AppMessageService } from '../../shared/services/app-message/app-message.service';
import { Observable } from 'rxjs';

interface IRealHeaders {
  label: string;
  value: string;
  required?: boolean;
  type?: string;
}

@Component({
  selector: 'app-excel',
  templateUrl: './excel.component.html',
  styleUrl: './excel.component.scss',
})
export class ExcelComponent {
  @Output() saveOn = new EventEmitter<any>();
  processExcelService: (data:any) => Observable<any>;
  saveExcelService: (data:any) => Observable<any>;
  processExcelServiceParameters:any;
  saveExcelServiceParameters:any;


  realHeaders: IRealHeaders[] = [];
  importedHeaders: string[] = [];
  importedData: any[] = [];
  mapping: { excelHeader: string; appField: string | null }[] = [];
  mappedData: any[];
  step = 1;
  loadingValue = 0;
  acceptedArray: any[] = [];
  acceptedArrayHeaders: IRealHeaders[] = [];
  failedArrayHeaders: IRealHeaders[] = [];
  failedArray: any[] = [];
  showProgressBar: boolean = false;
  selectedDatas = [];
  visible: boolean = false;
  constructor(
    private readonly excelService: ExcelService,
    private readonly messageService: AppMessageService
  ) {}

  exportData(data: any[], excelParameters: any[], filename: string) {
    this.excelService.exportToExcel(data, excelParameters, filename);
  }
  importData(
    headers: IRealHeaders[],
    processExcelService: (data:any) => Observable<any>,
    saveExcelService: (data:any) => Observable<any>,
    processExcelServiceParameters?:any,
    saveExcelServiceParameters?:any

  ) {
    this.realHeaders = headers;
    this.realHeaders = [
      { label: 'Yoksay', value: 'delete' },
      ...this.realHeaders,
    ];
    this.processExcelService = processExcelService;
    this.processExcelServiceParameters=processExcelServiceParameters ?? {};
    this.saveExcelService = saveExcelService;
    this.saveExcelServiceParameters=saveExcelServiceParameters ?? {}

    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
      fileInput.click();
    }
  }

  onFileChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.excelService.importFromExcel(file).then((data) => {
        this.importedData = data;
        this.importedHeaders = Object.keys(data[0]);
        this.mapping = this.importedHeaders.map((header) => ({
          excelHeader: header,
          appField: null,
        }));
        this.autoMapFromExcelHeaders();
        this.visible = true;
      });
    }
  }

  onFieldChange(index: number, selectedValue: string) {
    const filteredMap = this.mapping.filter(
      (e, i) => e.appField && e.appField === selectedValue && index !== i
    );

    if (filteredMap.length > 0 && selectedValue != 'delete') {
      this.messageService.errorToast(
        'Mükerrer Başlık',
        'Bu alan başka başlık ile daha önce ilişkilendirilmiş'
      );
      setTimeout(() => {
        this.mapping[index].appField = null;
      }, 20);

      return;
    }
    this.mapping[index].appField = selectedValue;
  }

  saveMapping() {
    const requiredFields =
      this.realHeaders.filter((h) => h.required === true) ?? [];
    this.mappedData = this.importedData.map((row) => {
      const mappedRow: any = {};
      for (const map of this.mapping) {
        if (map.appField !== 'delete') {
          const raw = row[map.excelHeader];

          const fieldType = this.getHeaderTypeByField(map.appField);
          if (fieldType === 'date') {
            mappedRow[map.appField!] = this.normalizeExcelDate(raw);
          } else {
            mappedRow[map.appField!] = raw;
          }
        }
      }
      return mappedRow;
    });

   this.acceptedArrayHeaders=this.realHeaders.slice(1)
    this.failedArrayHeaders = [
      { label: 'Hata Mesajları', value: 'failedMessages' },
      ...this.acceptedArrayHeaders,
    ];

    // eşleştirilen parametrelerini al
    const params = this.mapping.map((m) => m.appField);
    //zorunlu alan olup parametrelerde eşleştirilmeyen varmı bul
    const missingFields = requiredFields.filter(
      (field) => !params?.includes(field.value)
    );

    if (missingFields.length > 0) {
      const missingFieldLabels = missingFields.map((f) => f.label).join(', ');
      this.messageService.errorToast(
        'Zorunlu Alan',
        `Bazı zorunlu alanlar eksik: ${missingFieldLabels}. Lütfen tüm zorunlu alanları eşleştirin.`
      );
      return;
    }

    this.showProgressBar = true;
    this.step = 2;
    setTimeout(() => {
      this.loadingValue = 20;
    }, 1000);
    setTimeout(() => {
      this.loadingValue = 50;
    }, 2000);

    setTimeout(() => {
      this.processExcelData();
    }, 3000);
  }

  isMappingValid(): boolean {
    return this.mapping.every((map) => map.appField);
  }

  private processExcelData() {
    this.processExcelService({
      excelDatas:this.mappedData,
      ...this.processExcelServiceParameters
    }).subscribe({
      next: (res) => {
        this.acceptedArray = res.successfullArray ?? [];
        this.failedArray = res.failedArray ?? [];
        this.loadingValue = 100;
        this.showProgressBar = false;
      },
      error: () => {},
    });
  }
  saveSelectedDatas() {
    this.saveExcelService({
      selectedDatas:this.selectedDatas,
      ...this.saveExcelServiceParameters
    }).subscribe({
      next: (res) => {
        this.saveOn.emit(res);
        this.onClose();
      },
    });
  }

  onClose() {
    this.step = 1;
    this.loadingValue = 0;
    this.failedArray = [];
    this.failedArrayHeaders = [];
    this.realHeaders = [];
    this.acceptedArrayHeaders = [];
    this.acceptedArray = [];
    this.showProgressBar = false;
    this.importedHeaders = [];
    this.importedData = [];
    this.mapping = [];
    this.mappedData = [];
    this.selectedDatas = [];
    this.visible = false;
  }

  stepBack() {
    this.step = 1;
    this.loadingValue = 0;
    this.selectedDatas = [];
    this.showProgressBar = false;
    this.mappedData=[];
    this.acceptedArrayHeaders=[];
  }


  private normalizeHeader(v: any): string {
    return String(v ?? '')
      .trim()
      .toLocaleLowerCase('tr-TR')
      .replace(/ı/g, 'i')
      .replace(/ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/ş/g, 's')
      .replace(/ö/g, 'o')
      .replace(/ç/g, 'c')
      .replace(/[\s\-_./\\(){}[\],;:+*"'`~!@#$%^&=?<>|]/g, '');
  }

  /** Excel başlığına göre realHeaders içinden en uygun field'ı bul */
  private findBestMatchAppField(excelHeader: string): string | null {
    const h = this.normalizeHeader(excelHeader);
    if (!h) return null;

    const candidates = (this.realHeaders ?? []).filter(x => x?.value && x.value !== 'delete');

    const exact =
      candidates.find(x => this.normalizeHeader(x.label) === h) ??
      candidates.find(x => this.normalizeHeader(x.value) === h);
    if (exact) return exact.value;

    const contains =
      candidates.find(x => this.normalizeHeader(x.label).includes(h) || h.includes(this.normalizeHeader(x.label))) ??
      candidates.find(x => this.normalizeHeader(x.value).includes(h) || h.includes(this.normalizeHeader(x.value)));
    if (contains) return contains.value;

    const synonyms: Record<string, string[]> = {
      phone: ['telefon', 'tel', 'gsm', 'phone'],
      name: ['ad', 'adi', 'isim', 'name'],
      surname: ['soyad', 'soyadi', 'surname'],
      protocol: ['protokol', 'protocol', 'protocolno', 'protokolno'],
    };

    for (const c of candidates) {
      const cKey = this.normalizeHeader(c.label) || this.normalizeHeader(c.value);
      for (const [key, list] of Object.entries(synonyms)) {
        const hit = list.some(s => this.normalizeHeader(s) === h);
        if (hit && cKey.includes(key)) return c.value;
      }
    }

    return null;
  }

  private autoMapFromExcelHeaders(): void {
    const used = new Set<string>();

    for (let i = 0; i < this.mapping.length; i++) {
      const excelHeader = this.mapping[i].excelHeader;
      const match = this.findBestMatchAppField(excelHeader);

      if (match && match !== 'delete' && !used.has(match)) {
        this.mapping[i].appField = match;
        used.add(match);
      } else {
        this.mapping[i].appField = null;
      }
    }
  }


  private normalizeExcelDate(value: any): Date | null {
    if (value == null || value === '') return null;

    // 1) Eğer zaten Date ise
    if (value instanceof Date && !isNaN(value.getTime())) {
      return new Date(Date.UTC(value.getFullYear(), value.getMonth(), value.getDate(), 12, 0, 0));
    }

    if (typeof value === 'number' && isFinite(value)) {
      const excelEpoch = new Date(Date.UTC(1899, 11, 30));
      const utc = new Date(excelEpoch.getTime() + value * 86400000);
      return new Date(Date.UTC(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate(), 12, 0, 0));
    }

    if (typeof value === 'string') {
      const s = value.trim();
      if (!s) return null;

      const m1 = s.match(/^(\d{1,2})[./-](\d{1,2})[./-](\d{4})$/);
      if (m1) {
        const d = Number(m1[1]);
        const mo = Number(m1[2]) - 1;
        const y = Number(m1[3]);
        return new Date(Date.UTC(y, mo, d, 12, 0, 0));
      }

      const m2 = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
      if (m2) {
        const y = Number(m2[1]);
        const mo = Number(m2[2]) - 1;
        const d = Number(m2[3]);
        return new Date(Date.UTC(y, mo, d, 12, 0, 0));
      }

      const parsed = new Date(s);
      if (!isNaN(parsed.getTime())) {
        return new Date(Date.UTC(parsed.getFullYear(), parsed.getMonth(), parsed.getDate(), 12, 0, 0));
      }
    }

    return null;
  }

  private getHeaderTypeByField(field: string | null): string | undefined {
    if (!field) return undefined;
    return this.realHeaders.find(h => h.value === field)?.type;
  }

}
